/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../api-instance';
import { apiInstance } from '../api-instance';
import type {
  DeleteLlmModelCostPathParameters,
  ListLlmModelCostsParams,
  TLHTTPValidationError,
  TLLLMModelCostCreateRequest,
  TLLLMModelCostListResponse,
  TLLLMModelCostResponse,
  TLLLMModelCostUpdateRequest,
  UpdateLlmModelCostPathParameters,
} from './tessera-backend-api.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List Llm Model Costs
 */
export const listLlmModelCosts = (
  params?: ListLlmModelCostsParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLLLMModelCostListResponse>(
    { url: `/admin/llm-model-costs`, method: 'GET', params, signal },
    options,
  );
};

export const getListLlmModelCostsQueryKey = (params?: ListLlmModelCostsParams) => {
  return ['admin', 'llm-model-costs', ...(params ? [params] : [])] as const;
};

export const getListLlmModelCostsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLlmModelCosts>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListLlmModelCostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listLlmModelCosts>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLlmModelCostsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLlmModelCosts>>> = ({ signal }) =>
    listLlmModelCosts(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLlmModelCosts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListLlmModelCostsQueryResult = NonNullable<Awaited<ReturnType<typeof listLlmModelCosts>>>;
export type ListLlmModelCostsQueryError = ErrorType<TLHTTPValidationError>;

export function useListLlmModelCosts<
  TData = Awaited<ReturnType<typeof listLlmModelCosts>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params: undefined | ListLlmModelCostsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listLlmModelCosts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLlmModelCosts>>,
          TError,
          Awaited<ReturnType<typeof listLlmModelCosts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListLlmModelCosts<
  TData = Awaited<ReturnType<typeof listLlmModelCosts>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListLlmModelCostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listLlmModelCosts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLlmModelCosts>>,
          TError,
          Awaited<ReturnType<typeof listLlmModelCosts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListLlmModelCosts<
  TData = Awaited<ReturnType<typeof listLlmModelCosts>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListLlmModelCostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listLlmModelCosts>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Llm Model Costs
 */

export function useListLlmModelCosts<
  TData = Awaited<ReturnType<typeof listLlmModelCosts>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  params?: ListLlmModelCostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listLlmModelCosts>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListLlmModelCostsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Llm Model Costs
 */
export const prefetchListLlmModelCostsQuery = async <
  TData = Awaited<ReturnType<typeof listLlmModelCosts>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  params?: ListLlmModelCostsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listLlmModelCosts>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListLlmModelCostsQueryOptions(params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary List Llm Model Costs
 */
export const invalidateListLlmModelCosts = async (
  queryClient: QueryClient,
  params?: ListLlmModelCostsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListLlmModelCostsQueryKey(params) }, options);

  return queryClient;
};

/**
 * @summary Create Llm Model Cost
 */
export const createLlmModelCost = (
  tLLLMModelCostCreateRequest: BodyType<TLLLMModelCostCreateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLLLMModelCostResponse>(
    {
      url: `/admin/llm-model-costs`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: tLLLMModelCostCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateLlmModelCostQueryKey = (tLLLMModelCostCreateRequest?: BodyType<TLLLMModelCostCreateRequest>) => {
  return ['POST', 'admin', 'llm-model-costs', tLLLMModelCostCreateRequest] as const;
};

export const getCreateLlmModelCostQueryOptions = <
  TData = Awaited<ReturnType<typeof createLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLLLMModelCostCreateRequest: BodyType<TLLLMModelCostCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCreateLlmModelCostQueryKey(tLLLMModelCostCreateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof createLlmModelCost>>> = ({ signal }) =>
    createLlmModelCost(tLLLMModelCostCreateRequest, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof createLlmModelCost>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreateLlmModelCostQueryResult = NonNullable<Awaited<ReturnType<typeof createLlmModelCost>>>;
export type CreateLlmModelCostQueryError = ErrorType<TLHTTPValidationError>;

export function useCreateLlmModelCost<
  TData = Awaited<ReturnType<typeof createLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLLLMModelCostCreateRequest: BodyType<TLLLMModelCostCreateRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof createLlmModelCost>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createLlmModelCost>>,
          TError,
          Awaited<ReturnType<typeof createLlmModelCost>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateLlmModelCost<
  TData = Awaited<ReturnType<typeof createLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLLLMModelCostCreateRequest: BodyType<TLLLMModelCostCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createLlmModelCost>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createLlmModelCost>>,
          TError,
          Awaited<ReturnType<typeof createLlmModelCost>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateLlmModelCost<
  TData = Awaited<ReturnType<typeof createLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLLLMModelCostCreateRequest: BodyType<TLLLMModelCostCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create Llm Model Cost
 */

export function useCreateLlmModelCost<
  TData = Awaited<ReturnType<typeof createLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  tLLLMModelCostCreateRequest: BodyType<TLLLMModelCostCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCreateLlmModelCostQueryOptions(tLLLMModelCostCreateRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Create Llm Model Cost
 */
export const prefetchCreateLlmModelCostQuery = async <
  TData = Awaited<ReturnType<typeof createLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  tLLLMModelCostCreateRequest: BodyType<TLLLMModelCostCreateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getCreateLlmModelCostQueryOptions(tLLLMModelCostCreateRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Create Llm Model Cost
 */
export const invalidateCreateLlmModelCost = async (
  queryClient: QueryClient,
  tLLLMModelCostCreateRequest: BodyType<TLLLMModelCostCreateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getCreateLlmModelCostQueryKey(tLLLMModelCostCreateRequest) },
    options,
  );

  return queryClient;
};

/**
 * @summary Delete Llm Model Cost
 */
export const deleteLlmModelCost = (
  { costId }: DeleteLlmModelCostPathParameters,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<void>({ url: `/admin/llm-model-costs/${costId}`, method: 'DELETE', signal }, options);
};

export const getDeleteLlmModelCostQueryKey = ({ costId }: DeleteLlmModelCostPathParameters) => {
  return ['DELETE', 'admin', 'llm-model-costs', costId] as const;
};

export const getDeleteLlmModelCostQueryOptions = <
  TData = Awaited<ReturnType<typeof deleteLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { costId }: DeleteLlmModelCostPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDeleteLlmModelCostQueryKey({ costId });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteLlmModelCost>>> = ({ signal }) =>
    deleteLlmModelCost({ costId }, requestOptions, signal);

  return { queryKey, queryFn, enabled: costId !== null && costId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof deleteLlmModelCost>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeleteLlmModelCostQueryResult = NonNullable<Awaited<ReturnType<typeof deleteLlmModelCost>>>;
export type DeleteLlmModelCostQueryError = ErrorType<TLHTTPValidationError>;

export function useDeleteLlmModelCost<
  TData = Awaited<ReturnType<typeof deleteLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DeleteLlmModelCostPathParameters,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteLlmModelCost>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteLlmModelCost>>,
          TError,
          Awaited<ReturnType<typeof deleteLlmModelCost>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteLlmModelCost<
  TData = Awaited<ReturnType<typeof deleteLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DeleteLlmModelCostPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteLlmModelCost>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteLlmModelCost>>,
          TError,
          Awaited<ReturnType<typeof deleteLlmModelCost>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteLlmModelCost<
  TData = Awaited<ReturnType<typeof deleteLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: DeleteLlmModelCostPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Delete Llm Model Cost
 */

export function useDeleteLlmModelCost<
  TData = Awaited<ReturnType<typeof deleteLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { costId }: DeleteLlmModelCostPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDeleteLlmModelCostQueryOptions({ costId }, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Delete Llm Model Cost
 */
export const prefetchDeleteLlmModelCostQuery = async <
  TData = Awaited<ReturnType<typeof deleteLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { costId }: DeleteLlmModelCostPathParameters,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof deleteLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getDeleteLlmModelCostQueryOptions({ costId }, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Delete Llm Model Cost
 */
export const invalidateDeleteLlmModelCost = async (
  queryClient: QueryClient,
  { costId }: DeleteLlmModelCostPathParameters,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getDeleteLlmModelCostQueryKey({ costId }) }, options);

  return queryClient;
};

/**
 * @summary Update Llm Model Cost
 */
export const updateLlmModelCost = (
  { costId }: UpdateLlmModelCostPathParameters,
  tLLLMModelCostUpdateRequest: BodyType<TLLLMModelCostUpdateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLLLMModelCostResponse>(
    {
      url: `/admin/llm-model-costs/${costId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: tLLLMModelCostUpdateRequest,
      signal,
    },
    options,
  );
};

export const getUpdateLlmModelCostQueryKey = (
  { costId }: UpdateLlmModelCostPathParameters,
  tLLLMModelCostUpdateRequest?: BodyType<TLLLMModelCostUpdateRequest>,
) => {
  return ['PUT', 'admin', 'llm-model-costs', costId, tLLLMModelCostUpdateRequest] as const;
};

export const getUpdateLlmModelCostQueryOptions = <
  TData = Awaited<ReturnType<typeof updateLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { costId }: UpdateLlmModelCostPathParameters,
  tLLLMModelCostUpdateRequest: BodyType<TLLLMModelCostUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUpdateLlmModelCostQueryKey({ costId }, tLLLMModelCostUpdateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof updateLlmModelCost>>> = ({ signal }) =>
    updateLlmModelCost({ costId }, tLLLMModelCostUpdateRequest, requestOptions, signal);

  return { queryKey, queryFn, enabled: costId !== null && costId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof updateLlmModelCost>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UpdateLlmModelCostQueryResult = NonNullable<Awaited<ReturnType<typeof updateLlmModelCost>>>;
export type UpdateLlmModelCostQueryError = ErrorType<TLHTTPValidationError>;

export function useUpdateLlmModelCost<
  TData = Awaited<ReturnType<typeof updateLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateLlmModelCostPathParameters,
  tLLLMModelCostUpdateRequest: BodyType<TLLLMModelCostUpdateRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateLlmModelCost>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateLlmModelCost>>,
          TError,
          Awaited<ReturnType<typeof updateLlmModelCost>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateLlmModelCost<
  TData = Awaited<ReturnType<typeof updateLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateLlmModelCostPathParameters,
  tLLLMModelCostUpdateRequest: BodyType<TLLLMModelCostUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateLlmModelCost>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateLlmModelCost>>,
          TError,
          Awaited<ReturnType<typeof updateLlmModelCost>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateLlmModelCost<
  TData = Awaited<ReturnType<typeof updateLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateLlmModelCostPathParameters,
  tLLLMModelCostUpdateRequest: BodyType<TLLLMModelCostUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update Llm Model Cost
 */

export function useUpdateLlmModelCost<
  TData = Awaited<ReturnType<typeof updateLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { costId }: UpdateLlmModelCostPathParameters,
  tLLLMModelCostUpdateRequest: BodyType<TLLLMModelCostUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUpdateLlmModelCostQueryOptions({ costId }, tLLLMModelCostUpdateRequest, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Update Llm Model Cost
 */
export const prefetchUpdateLlmModelCostQuery = async <
  TData = Awaited<ReturnType<typeof updateLlmModelCost>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { costId }: UpdateLlmModelCostPathParameters,
  tLLLMModelCostUpdateRequest: BodyType<TLLLMModelCostUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateLlmModelCost>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getUpdateLlmModelCostQueryOptions({ costId }, tLLLMModelCostUpdateRequest, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Update Llm Model Cost
 */
export const invalidateUpdateLlmModelCost = async (
  queryClient: QueryClient,
  { costId }: UpdateLlmModelCostPathParameters,
  tLLLMModelCostUpdateRequest: BodyType<TLLLMModelCostUpdateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getUpdateLlmModelCostQueryKey({ costId }, tLLLMModelCostUpdateRequest) },
    options,
  );

  return queryClient;
};
